const collectSubCategoryMetaData = (
  displayName: string,
  metaTitle: string,
  metaDescription: string,
) => ({
  title: metaTitle || `Design Free Printable ${displayName} Online`,
  ogTitle: metaTitle || `Design Free Printable ${displayName} Online`,
  description:
    metaDescription ||
    `Explore professionally designed selection of pre-made free and paid ${displayName}. Use our Photo editor to customize your design in seconds.`,
  ogDescription:
    metaDescription ||
    `Explore professionally designed selection of pre-made free and paid ${displayName}. Use our Photo editor to customize your design in seconds.`,
  canonicalUrl: window.location.href,
});

export default collectSubCategoryMetaData;
